import { Spinner } from 'react-bootstrap'

import { RoomSession } from '../../../../../models/Room'

import UserWithAvatar from '../../common/user/UserWithAvatar'

import { ExplainedResult } from './models'

interface ResultExplainerViewProps {
  resultToExplain: string
  explanationResult: ExplainedResult | null
  isLoading: boolean
  roomSession?: RoomSession | null
}

export const ResultExplainerView: React.FC<ResultExplainerViewProps> = ({ resultToExplain, explanationResult, isLoading, roomSession }) => {
  if (isLoading) {
    return (
      <div className='d-flex align-items-center justify-content-center mt-5'>
        <Spinner />
      </div>
    )
  }

  return (
    <div className='d-flex flex-column gap-2 zocks-py-1.25 zocks-px-1.25'>
      <div className='lead-extra-small'>Result to explain</div>
      <div className='d-flex flex-column p-3 result-to-explain-container'>{resultToExplain}</div>
      <div className='lead-extra-small'>Explanation</div>
      <div className='d-flex gap-2 p-3 explanation-container'>
        <i className='bi bi-stars zocks-text-primary' />
        <div className='paragraph-medium'>{explanationResult ? explanationResult.explanation : 'Explanation cannot be determined at this time'}</div>
      </div>
      {explanationResult && roomSession && (
        <div className='mt-4 d-flex flex-column gap-4'>
          {explanationResult.transcript.map((t, idx) => {
            const user = roomSession.users.find((u) => u.id === t.userId)
            const userName = user ? user.name : 'Unknown'

            return (
              <div key={`${t.userId}-${idx}`} className='d-flex flex-column gap-2'>
                <div className='d-flex align-items-center gap-2 result-explainer-user'>
                  <UserWithAvatar name={userName} displayName={false} />
                  <div className='paragraph-medium bold'>{userName}</div>
                </div>
                <div className='d-flex p-3 gap-2 result-explainer-transcript-container'>
                  <i className='bi bi-quote' />
                  <div className='paragraph-medium'>{t.content}</div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
